import { render } from "./Pago_categoriaShow.vue?vue&type=template&id=9348a148"
import script from "./Pago_categoriaShow.vue?vue&type=script&lang=js"
export * from "./Pago_categoriaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__